interface EmergencyState {
  isActive: boolean;
  disabledFeatures: Set<string>;
  startTime: number;
  reason: string;
}

class EmergencyMode {
  private static instance: EmergencyMode;
  private state: EmergencyState = {
    isActive: false,
    disabledFeatures: new Set(),
    startTime: 0,
    reason: ''
  };

  static getInstance(): EmergencyMode {
    if (!EmergencyMode.instance) {
      EmergencyMode.instance = new EmergencyMode();
    }
    return EmergencyMode.instance;
  }

  activate(reason: string, features: string[] = []): void {
    console.warn('🚨 Emergency mode activated:', reason);
    
    this.state = {
      isActive: true,
      disabledFeatures: new Set([
        'external-analytics',
        'third-party-scripts', 
        'non-critical-apis',
        'calendar-integration',
        'social-media-widgets',
        ...features
      ]),
      startTime: Date.now(),
      reason
    };

    // Disable problematic features immediately
    this.disableExternalResources();
  }

  deactivate(): void {
    console.log('✅ Emergency mode deactivated');
    this.state = {
      isActive: false,
      disabledFeatures: new Set(),
      startTime: 0,
      reason: ''
    };
  }

  isFeatureDisabled(feature: string): boolean {
    return this.state.isActive && this.state.disabledFeatures.has(feature);
  }

  getStatus(): EmergencyState {
    return { ...this.state };
  }

  private disableExternalResources(): void {
    // Remove any existing external scripts that might be causing issues
    const externalScripts = document.querySelectorAll('script[src*="calendar.google.com"], script[src*="facebook."], script[src*="reddit."], script[src*="tiktok."]');
    externalScripts.forEach(script => {
      console.warn('🚫 Emergency mode removing external script:', script.getAttribute('src'));
      script.remove();
    });

    // Disable external stylesheet loading
    const externalStyles = document.querySelectorAll('link[href*="googleapis.com"], link[href*="calendar.google.com"]');
    externalStyles.forEach(link => {
      console.warn('🚫 Emergency mode disabling external stylesheet:', link.getAttribute('href'));
      (link as HTMLLinkElement).disabled = true;
    });
  }

  // Auto-deactivate after 30 minutes unless critical errors persist
  scheduleAutoDeactivation(): void {
    setTimeout(() => {
      if (this.state.isActive && Date.now() - this.state.startTime > 30 * 60 * 1000) {
        console.log('⏰ Auto-deactivating emergency mode after 30 minutes');
        this.deactivate();
      }
    }, 30 * 60 * 1000);
  }
}

export const emergencyMode = EmergencyMode.getInstance();